var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.80819 7.37585C9.79106 5.58952 11.3009 4.72033 11.37 4.67957C10.5157 3.45732 9.18994 3.29007 8.72518 3.27688C7.61159 3.16179 6.53287 3.93027 5.9666 3.93027C5.38748 3.93027 4.51423 3.28887 3.57432 3.30626C2.36289 3.32544 1.23035 4.0124 0.608428 5.0794C-0.673325 7.25476 0.283709 10.4516 1.51104 12.2103C2.12501 13.0711 2.84355 14.0344 3.78285 13.999C4.70258 13.9625 5.04564 13.4248 6.15556 13.4248C7.25447 13.4248 7.57735 13.999 8.53622 13.9781C9.5226 13.9625 10.1433 13.1131 10.7365 12.2439C11.4465 11.2572 11.7314 10.2849 11.743 10.2352C11.7192 10.2274 9.82714 9.51824 9.80819 7.37585Z",
    fill: "#434343"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99861 2.26768C8.49272 1.66104 8.83151 0.837416 8.73794 0C8.02246 0.0317702 7.12658 0.485545 6.61229 1.07839C6.15487 1.6005 5.74759 2.4577 5.854 3.26155C6.65693 3.32029 7.48188 2.86472 7.99861 2.26768Z",
    fill: "#434343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/AppleIcon.ccdd34706ab81dac7e4e8c68e6fc9456.svg";
export { ForwardRef as ReactComponent };